import { render, staticRenderFns } from "./UnprocessedOrders.vue?vue&type=template&id=9ef5ae96&"
import script from "./UnprocessedOrders.vue?vue&type=script&lang=js&"
export * from "./UnprocessedOrders.vue?vue&type=script&lang=js&"
import style0 from "./UnprocessedOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports